<div *ngIf="show" class="list-type-tree wm-tree" [ngClass]="{'searchenabled': hasSearch}">
    <div *ngIf="hasSearch" class="wm-search-container">
        <wms-search [name]="searchElementName" (onSearch)="onSearch($event)"></wms-search>
    </div>
    <div class="treecontent-wrap">
        <ul #treeRoot name="wm-service-treecontent" class="treecontent">
            <wms-tree-node *ngFor="let item of filteredData; index as i" [level]="1" [dataItem]="item" [expandOnClick]="expandOnClick"
                [hideChildren]="hideChildren" [skipChildNodeSearch]="skipChildNodeSearch" [expandedNodes]="expandedNodes"
                [expandNode]="canExpandNode(item.id)" [id]="i+1" (nodeClick)="nodeClick.emit($event)" (onExpand)="onExpand.emit($event); onNodeExpand($event); " [searchText]="searchText" [selectedNode]="selectedNode" [getChildren]="getChildren" [sortBy]="sortBy"
                [enableDragDrop]="enableDragDrop" (nodeDragStart)="onNodeDragStart($event)" (nodeDragEnd)="onNodeDragEnd($event)" (nodeDropped)="onNodeDropped($event)">
            </wms-tree-node>
            <wms-spinner *ngIf="showSpinner" [caption]="'Loading...'" [size]="'md'"></wms-spinner>
        </ul>
        <div class="wm-connector-msg" *ngIf="!data?.children?.length && nodatamsg"> {{nodatamsg}} </div>
    </div>
    <button type="button" class="focus-capture-element" tabindex="-1"></button>
</div>
